/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutoEdrBlacklistedDomainRequest
 */
export interface AutoEdrBlacklistedDomainRequest {
    /**
     * 
     * @type {string}
     * @memberof AutoEdrBlacklistedDomainRequest
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof AutoEdrBlacklistedDomainRequest
     */
    reason: string;
    /**
     * 
     * @type {boolean}
     * @memberof AutoEdrBlacklistedDomainRequest
     */
    isARegex: boolean;
}

/**
 * Check if a given object implements the AutoEdrBlacklistedDomainRequest interface.
 */
export function instanceOfAutoEdrBlacklistedDomainRequest(value: object): value is AutoEdrBlacklistedDomainRequest {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('isARegex' in value) || value['isARegex'] === undefined) return false;
    return true;
}

export function AutoEdrBlacklistedDomainRequestFromJSON(json: any): AutoEdrBlacklistedDomainRequest {
    return AutoEdrBlacklistedDomainRequestFromJSONTyped(json, false);
}

export function AutoEdrBlacklistedDomainRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoEdrBlacklistedDomainRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'reason': json['reason'],
        'isARegex': json['isARegex'],
    };
}

export function AutoEdrBlacklistedDomainRequestToJSON(value?: AutoEdrBlacklistedDomainRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'domain': value['domain'],
        'reason': value['reason'],
        'isARegex': value['isARegex'],
    };
}

